<form #theForm="ngForm" name="trackingField" (ngSubmit)="ok()" [formGroup]="formData" novalidate>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Tracking field</h4>
  </div>

  <div class="form-group modal-body">

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label title="Write the name/key to identify this tracking field. It could make sense to incl the document type as part of it.">Key Name *</label>
          <input formControlName="name" class="form-control" ngbAutofocus required />
          <div
            [class.invisible]="!formData?.get('name')?.hasError('required') || formData?.get('name')?.untouched"
            class="error">
            <span>Required</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label title="Pick the document type this tracking field should be associated with.">Document type *</label>
          <select class="form-control" formControlName="distributionObjectId">
            @for (item of distroDisplays; track item) {
              <option [ngValue]="item.DistributionObjectsId">
                {{item.DisplayName}}
              </option>
            }
          </select>
          <div
            [class.invisible]="!formData?.get('distributionObjectId')?.hasError('min') || formData?.get('distributionObjectId')?.untouched"
            class="error">
            <span>Required</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <app-singleselectbox
          caption="Type"
          formControlName="type"
          [dataSource]="trackingFieldTypeOptions()"
          valueExpr="id"
          displayExpr="name">
        </app-singleselectbox>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="control control-checkbox lg control-form-group">
            <label title="Adds a coloumn with the specified tracking field to the tracking search results view.">
              Show in search preview
              <input type="checkbox" formControlName="showInSearchPreview" class="form-control" />
              <i></i>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        @if (selectedType() === 'xpath') {
          <app-xpath
            formControlName="xpath"
            [documentTypeId]="documentTypeId()"
            caption="XPath"
            helpText="XPath expression that define the value of the tracking field."
            (loadingChange)="loadingChange($event)">
          </app-xpath>
        }

        @if(selectedType() === 'contextproperty') {
          <app-textbox
            caption="Context Property"
            formControlName="contextProperty"
            helpText="Context property name to read the value from.">
          </app-textbox>

          <app-textbox
            caption="Context Property Namespace"
            formControlName="contextPropertyNamespace"
            helpText="Namespace for the context property.">
          </app-textbox>
        }

        @if(selectedType() === 'macro') {
          <app-textbox
            caption="Macro"
            formControlName="macro"
            helpText="Macro expression used to compute the value using Link Macros.">
          </app-textbox>
        }
      </div>
    </div>

    <app-developer-data-field formControlName="dataField" [dataFieldGroups]="dataFieldGroups" [dataFieldTypes]="dataFieldTypes"
      groupTooltip="Grouping of tracking fields displayed in the tracking search." typeTooltip="Data type of the tracking field (e.g., bool, string, or array)."
      displayNameTooltip="Label name of the tracking field displayed."
      dataLengthTooltip="Maximum length of the tracking field value. It will only affect what you can search for, not the value that is actually tracked'"
      regexTooltip="Type in a regex if the input should match a specific patterns. Could be for a date in format YYYY-MM-DD that can be expressed with this reges: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$"
      regexTextTooltip="The error text to indicate the regex requirement. E.g. in the above the input value must match a date in the format YYYY-MM-DD"
      infoTextTooltip="Tooltip text displayed when hovering over the tracking field displayed in the tracking search." defaultValueTooltip="Value to be pre-filled, displayed in the tracking search."
      sortOrderTooltip="Order of the tracking field within the group, displayed in the tracking search page." source="trackingField">
    </app-developer-data-field>
  </div>

  <footer class="modal-footer">
    <div class="button-container">
      <app-button primary submit width="100%" [disabled]="formData.invalid">Ok</app-button>
      <app-button secondary width="100%" (buttonClick)="cancel()">Cancel</app-button>
    </div>
  </footer>
</form>
